import React from 'react';
import AmiraIconButton, { ICON_BUTTON_TYPES } from '../Global/AmiraIconButton2/AmiraIconButton2';

export default function FreeAnswerSubmitButton({ enabled, onSubmit, showPointer }) {
  return (
    <div className="freeAnswer__submit">
      <AmiraIconButton
        type={ICON_BUTTON_TYPES.SUBMIT}
        oblong
        onClick={() => enabled && onSubmit()}
        disabled={!enabled}
        assessment={true}
        pointerPosition="left"
        showPointer={showPointer}
      />
    </div>
  );
}
